<ng-container *appVar="menuEnabled|async as menuEnabled">
    <div class="content-layout" *appVar="menuShown|async as menuShown">
        <!-- Toaster -->
        <toaster-container [toasterconfig]="toasterConfig"></toaster-container>

        <!-- Header -->
        <app-header class="header"></app-header>

        <ng-container *ngIf="menuEnabled">
            <app-menu class="menu collapsed" [collapsed]="true">
            </app-menu>
            <mat-sidenav class="menu" mode="over" position="start"
                         [disableClose]="true" [opened]="menuShown">
                <app-menu [collapsed]="false">
                </app-menu>
            </mat-sidenav>
        </ng-container>

        <mat-sidenav-container class="container" [ngClass]="{'with-menu': menuEnabled}"
                               (backdropClick)="onBackDropClicked()">
            <mat-sidenav #entityTreePanel
                         [opened]="showEntityTree|async"
                         (openedChange)="onEntityTreeOpenChanged($event)"
                         (openedStart)="onEntityTreeAnimationStart()"
                         (closedStart)="onEntityTreeAnimationStart()"
                         [mode]="sideNavMode|async"
                         class="sidenav-container entity-tree" position="start" [disableClose]="true">
                <app-entity-tree></app-entity-tree>
            </mat-sidenav>

            <mat-sidenav-content class="content o-visible_">
                <router-outlet></router-outlet>
            </mat-sidenav-content>
        </mat-sidenav-container>

        <!-- Footer -->
        <app-footer [withMenu]="menuEnabled"></app-footer>
    </div>
</ng-container>
